import React, { useState, useEffect, useRef } from 'react';
import logo from './ms_logo.png';
import '../App.css';
import { ApiGet } from '../Api';
import { GetTime } from '../Function';
import TuiGrid from 'tui-grid';
import Grid from '@toast-ui/react-grid';
import 'tui-pagination/dist/tui-pagination.css';

function MsMonitoring() {  
  const apiUrl = process.env.REACT_APP_API_DOMAIN + 'ms-label/';
  const dataSource = {
    api: {
      readData: { url: apiUrl + 'grid', method: 'GET' }
    }
  };

  const backgroundMainColor = 'rgb(12, 35, 64)';
  const backgroundSubColor = 'rgb(18, 46, 78)';
  const logoHeight = '60px'; //logo height + logo paddingTop
  const gridGap = window.innerWidth > 800 ? 30 : 20;
  const titleColor= 'rgb(153, 255, 153)';
  const headerHeight = window.innerWidth > 800 ? 60 : 40;
  const tableCellGap = 5;

  const [gridStyle, setGridStyle] = useState(GetGridStyle());
  const toastGridDivRef = useRef(null);
  const [certification, setCertification] = useState(process.env.REACT_APP_DEV === 'true');
  const [headerText, setHeaderText] = useState({ totalCount: 0, readyCount: 0, productCount: 0, readyRatio: 0 })
  const [isMobile, setIsMobile] = useState(false);
  const [refreshTime, setRefreshTime] = useState('0001-01-01 00:00:00');
  const [nowPerPage, setNowPerPage] = useState(10);

  function Resize() {
    //height가 감소될 때 toast grid height 때문에 height가 줄어들지 않는 오류 방지
    gridReference.current.getInstance().setBodyHeight(0);

    setGridStyle(GetGridStyle());
  };

  useEffect(() => {
    document.title = 'MS MONITORING';
    if(!certification) {
      if (document.referrer !== process.env.REACT_APP_URL_MS && document.referrer !== process.env.REACT_APP_URL_MS + 'main' && document.referrer !== process.env.REACT_APP_URL_MS + 'main#' && document.referrer !== process.env.REACT_APP_URL_MS + 'main?APPTYPE=APP') {
        window.location.href = process.env.REACT_APP_URL_MS + 'main';
      } else {
        setCertification(true);
      }
    } 

    setIsMobile(/mobile/i.test(navigator.userAgent));
    window.addEventListener('resize', Resize);

    Inquiry();

    setInterval(()=>{
      Inquiry();
    }, 1000 * 60);

    return () => {
      window.removeEventListener('resize', Resize);
    };
  }, []);

  useEffect(() => {
    if (toastGridDivRef.current === null) {
      return;
    }
    const instance = gridReference.current.getInstance();

    //그리드를 감싸는 div의 height를 구해 그리드의 heigth 결정
    const toastGridBodyHeight = toastGridDivRef.current.offsetHeight - 40 - headerHeight;

    instance.setBodyHeight(toastGridBodyHeight);

    //그리드의 행 높이로 나눈값을 가까운 정수 내림값으로 한 페이지 당 표현할 행 수를 결정(현재 페이지 당 표현할 행수와 계산된 값이 다를 경우 적용)
    const toastGridPerPage = Math.floor((toastGridBodyHeight - tableCellGap) / (40 + 10)); //(body - tableCellGap) / (cell height + margin)의 내림값, 마지막 행의 셀의는 간격이 없기 때문
    if (nowPerPage !== toastGridPerPage) {
      instance.setPerPage(toastGridPerPage);
      setNowPerPage(toastGridPerPage);
    }
  }, [gridStyle]);

  TuiGrid.setLanguage('ko');
  TuiGrid.applyTheme('custom', {
    outline: {
      border: backgroundMainColor
    },
    scrollbar: {
     background: backgroundMainColor,
     border: backgroundMainColor
    },
    area: {
      body: {
        background: backgroundMainColor
      }
    },
    cell: {
      normal: {
        background: 'rgb(34, 55, 82)',//'rgb(45, 73, 108)',
        text: 'white',
        border: 'rgb(18, 46, 78)',
        
        showVerticalBorder: true,
        showHorizontalBorder: true
      },
      header: {
        background: backgroundSubColor,
        text: 'white',
        border: 'rgb(18, 46, 78)',
      },
      selectedHeader: {
        background: backgroundSubColor
      },
      focused: {
        border: 'none',
      }
    }
  });

  function Inquiry() {
    SetHeaderText();

    MoveNextPage();

    setRefreshTime(GetTime());
  }

  function Reload() {
    SetHeaderText();

    gridReference.current.getInstance().readData(1);

    setRefreshTime(GetTime());
  }

  async function SetHeaderText() {
    const response = await ApiGet(apiUrl + 'header');
    if (response !== null && response.ok) {
      const json = await response.json();
      const data = json.data[0];
      setHeaderText({ 
        totalCount: data.total_order_count, 
        readyCount: data.ready_count, 
        productCount: data.product_count, 
        readyRatio: parseFloat((100 * data.product_count / data.total_order_count).toFixed(2)) });
    }
  }

  function MoveNextPage() {
    if (toastGridDivRef.current === null) {
      return;
    }
    const pagination = gridReference.current.getInstance().getPagination();

    const lastPage = Math.ceil(pagination._options.totalItems / pagination._options.itemsPerPage);

    if (pagination._currentPage === lastPage) {
      pagination.movePageTo(1);
    } else {
      pagination.movePageTo(pagination._currentPage + 1);
    }
  }

  function ChangeFullscreen() {
    if (document.fullscreenElement) {
      document.exitFullscreen();
      return;
    }

    const elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { //Firefox
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { //Chrome, Safari, Opera
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { //IE/Edge
      elem.msRequestFullscreen();
    }
  }

  const buttonStyle = { backgroundColor: backgroundMainColor, color: 'rgb(204,204,204)', border: 'none', fontSize: 30 };

  function GetGridStyle() {
    return {
      display: 'grid',
      gap: gridGap,
      padding: gridGap,
      backgroundColor: backgroundMainColor,
      width: '100vw',
      height: `calc(100vh - ${logoHeight})`,
      boxSizing: 'border-box', //패딩을 포함하여 크기 계산
      overflow: 'auto',
      scrollbarWidth: 'none',
      gridTemplateColumns: window.innerWidth > 800 ? 'repeat(4, 1fr)' : 'repeat(2, 1fr)',
      gridTemplateRows: window.innerWidth > 800 ? '200px 1fr' : '200px 200px 400px'
    };
  };

  const itemStyle = {
    backgroundColor: backgroundSubColor,
    borderRadius: '10px',
  };

  const textItemStyle = {
    ...itemStyle,
    fontWeight: 'bold', 
    height: 200, 
    lineHeight: '80px',
    fontFamily: 'Arial, sans-serif', 
    color: 'rgb(255, 255, 102)', 
    fontSize: window.innerWidth > 800 ? 45 : 25, 
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  };
  
  const headerStyle = {
    color: titleColor,
    marginTop: window.innerWidth > 800 ? 30 : 20
  };

  const columnArray = [
    { name: 'cust_cd', header: '일련번호', align: 'center', width: 'auto', minWidth: 70, resizable: true },
    { name: 'cust_nm', header: '거래처', align: 'center', width: 'auto', minWidth: 70, resizable: true },
    { name: 'item_nm', header: '품명', align: 'center', width: 'auto', minWidth: 70, resizable: true },
    { name: 'moldyn', header: '목형(칼)', align: 'center', width: 120, resizable: true },
    { name: 'fabricyn', header: '원단', align: 'center', width: 70, resizable: true },
    { name: 'panyn', header: '판', align: 'center', width: 70, resizable: true },
    { name: 'inkyn', header: '잉크', align: 'center', width: 70, resizable: true },
    { name: 'out_status', header: '최종상태', align: 'center', width: 'auto', minWidth: 130, resizable: true },
    { name: 'due_dt', header: '납기일', align: 'center', width: 'auto', minWidth: 70, resizable: true }
  ];

  const gridReference = useRef(); //그리드 참조
  const [grid, setGrid] = useState(
    <Grid
      ref={gridReference} //그리드 참조
      width={'auto'}
      bodyHeight={0} 
      header={{ height: headerHeight }}
      data={dataSource}
      columns={columnArray}
      pagination={true}
      pageOptions={{ useClient: false, perPage: nowPerPage }}
      scrollY={false}
      onGridUpdated={OnGridUpdated}
      onGridMounted={Resize}
    />
  );

  function OnGridUpdated(event) {
    let allColumnWidth = 0;
    const tempColumnArray = [...columnArray];
    const columns = gridReference.current.getInstance().getColumns();

    for (const index in columns) {
      allColumnWidth += columns[index].baseWidth + tableCellGap;
    }
    
    //마지막 컬럼에는 우측에 5px 여백이 안생기기 때문에 계산할 때 -5
    if (allColumnWidth < toastGridDivRef.current.offsetWidth) { //그리드 컬럼들의 width 총합이 그리드를 감싸는 div의 width보다 작을 경우 나머지 width를 품명 컬럼에게 배정
      tempColumnArray[2].width = columns[2].baseWidth + toastGridDivRef.current.offsetWidth - allColumnWidth - tableCellGap;
    } else { //그리드 컬럼들의 width 총합이 그리드를 감싸는 div의 width보다 클 경우 품명 컬럼의 width를 줄임
      if (window.innerWidth > 800) {
        tempColumnArray[2].width = columns[2].baseWidth - (allColumnWidth - toastGridDivRef.current.offsetWidth) - tableCellGap;
      }
    }

    event.instance.setColumns(tempColumnArray);
  }

  return (
    <div>
      {certification && <div onContextMenu={(event)=>{ event.preventDefault(); }} style={{ userSelect: 'none' }}>
        <div style={{ backgroundColor: backgroundMainColor, paddingTop: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <img src={logo} height={'40px'} style={{ marginLeft: '20px' }}/>

          <div style={{ marginRight: '1vw' }}>
            <button title={refreshTime} onClick={Reload} style={buttonStyle}>⟳</button>
            {!isMobile && <button title={document.fullscreenElement ? '최소화' : '최대화'} onClick={ChangeFullscreen} style={buttonStyle}>◱</button>}
          </div>
        </div>

        <div style={gridStyle}>
          <div style={textItemStyle}>
            <div style={headerStyle}>총 주문수(건)</div>
            <div>{headerText.totalCount}</div>
          </div>

          <div style={textItemStyle}>
            <div style={headerStyle}>작업준비(건)</div>
            <div>{headerText.readyCount}</div>
          </div>

          <div style={textItemStyle}>
            <div style={headerStyle}>생산(건)</div>
            <div>{headerText.productCount}</div>
          </div>

          <div style={textItemStyle}>
            <div style={headerStyle}>준비 완료율(%)</div>
            <div>{headerText.readyRatio}</div>
          </div>

          <div id={window.innerWidth > 800 ? 'ms' : 'ms-mobile'} ref={toastGridDivRef} style={{...itemStyle, gridColumn : '1 / -1', backgroundColor: backgroundMainColor }}>
            {grid}
          </div>
        </div>
      </div>}
    </div>
  );
}

export default MsMonitoring;